import { Component, OnInit } from '@angular/core';
import { AuthService } from '../../../services/auth/auth.service';
import { LoginService } from '../../../services/login/login.service';
import { Router } from '@angular/router';

import { Usuario } from '../../../../model/interface/Usuario';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'app-admin-navbar',
  templateUrl: './admin-navbar.component.html',
  styleUrls: ['./admin-navbar.component.css'],
})
export class AdminNavbarComponent implements OnInit {

  user: Usuario;
  ordenesDeCompraUrl = '';
  productosImportacionUrl = '';

  constructor(
    private _authService: AuthService,
    private router: Router,
    private _loginService: LoginService,
  ) {
    this.user = this._authService.getUser();
  }

  ngOnInit() {
    this.user = this._authService.getUser();
    const token = this._authService.getToken();
    this.ordenesDeCompraUrl = environment.ORDEN_DE_COMPRAS_URL;
    this.productosImportacionUrl = environment.PRODUCTOS_IMPORTACION_URL;
  }

  signOut() {

    this._loginService.cerrarSesion();
    this._authService.deleteToken();
    this.router.navigate(['/administrador']);
  }

  public goToCotizaciones() {
    const token = this._authService.getToken();
    const url = environment.COTIZACIONES_URL + 'auth?t=' + token;
    window.location.href = url;
  }

  private evaluateRol() {
    const isAdmin = this._authService.isAdmin();
    if (!isAdmin) {
      this.goToCotizaciones();
    }
  }


}



// WEBPACK FOOTER //
// /app/src/app/components/structure/admin-navbar/admin-navbar.component.ts